import CDNVhostRepositoryInterface, {
  CDNVhostCreateInterface,
  CDNVhostInterface, XDNFeaturesInterface,
} from '@/services/Vhost/CDN/Interfaces';
import { AxiosInstance } from 'axios';

export class CDNVhostRepository implements CDNVhostRepositoryInterface {
  constructor(private axios: AxiosInstance) {}

  public async createVhost(
    data: CDNVhostCreateInterface
  ): Promise<CDNVhostInterface> {
    const res = await this.axios.post("/vhost-management/vhost", data);
    return res.data;
  }

  public async getVhosts(): Promise<CDNVhostInterface[]> {
    const res = await this.axios.get("/vhost-management/vhost");
    return res.data;
  }

  public async searchVhost(search: string): Promise<CDNVhostInterface[]> {
    const res = await this.axios.post("/vhost-management/vhost/search", {
      domain: search,
    });

    return res.data;
  }

  public async getVhostsBatch(
    offset: number,
    limit: number,
    search?: string
  ): Promise<CDNVhostInterface[]> {
    let url = `/vhost-management/vhost/batch?offset=${offset}&limit=${limit}`;
    if (search && search.trim() !== "") {
      url = `${url}&search=${search}`;
    }

    const res = await this.axios.get(url);
    return res.data;
  }

  public async getVhostsCount(): Promise<number> {
    const res = await this.axios.get(`/vhost-management/vhost/count`);
    return res.data;
  }

  public async deleteVhost(websiteId: number): Promise<void> {
    await this.axios.delete(`/vhost-management/vhost/${websiteId}`);
  }

  public async clearCache(websiteId: number): Promise<void> {
    await this.axios.post(`/vhost-management/vhost/${websiteId}/clear`);
  }

  public async enableXDN(websiteId: number): Promise<void> {
    await this.axios.post(`/vhost-management/vhost/${websiteId}/xdn`);
  }

  public async disableXDN(websiteId: number): Promise<void> {
    await this.axios.delete(`/vhost-management/vhost/${websiteId}/xdn`);
  }

  public async enableCDN(websiteId: number): Promise<void> {
    await this.axios.patch(`/vhost-management/vhost/${websiteId}/cdn`);
  }

  public async disableCDN(websiteId: number): Promise<void> {
    await this.axios.delete(`/vhost-management/vhost/${websiteId}/cdn`);
  }

  public async syncXDNs(): Promise<void> {
    await this.axios.post("/vhost-management/vhost/resync", {});
  }

  public async getXDNFeatures(
    websiteId: number
  ): Promise<XDNFeaturesInterface> {
    const response = await this.axios.get(
      `/vhost-management/vhost/${websiteId}/xdn/features`
    );

    return response.data;
  }

  public async setXDNFeatures(
    websiteId: number,
    data: XDNFeaturesInterface
  ): Promise<void> {
    await this.axios.post(
      `/vhost-management/vhost/${websiteId}/xdn/features`,
      data
    );
  }

  public async deleteXDNFeatures(websiteId: number): Promise<void> {
    await this.axios.delete(
      `/vhost-management/vhost/${websiteId}/xdn/features`
    );
  }

  public async updateServerIps(serverId: string): Promise<void> {
    await this.axios.patch(`/vhost-management/vhost/servers/${serverId}`);
  }
}
